import { Operator } from "./table-types";

const stringOperators: { [key: string]: Operator } = {
  is: {
    id: 'is',
    name: 'is',
    control: 'select',
  },
  not: {
    id: 'not',
    name: 'is not',
    control: 'select',
  },
  contains: {
    id: 'contains',
    name: 'contains',
    control: 'text',
  },
  anyOf: {
    id: 'anyOf',
    name: 'is any of',
    control: 'multi',
  },
  noneOf: {
    id: 'noneOf',
    name: 'is none of',
    control: 'multi',
  },
};

const baseOperators: { [key: string]: Operator } = {
  
  truthy: {
    id: 'truthy',
    name: 'is not empty',
  },
  falsy: {
    id: 'falsy',
    name: 'is empty',
  },
};

const numberOperators: { [key: string]: Operator } = {
  is: {
    id: 'is',
    name: 'is',
    control: 'number',
  },
  not: {
    id: 'not',
    name: 'is not',
    control: 'number',
  },
  greaterThan: {
    id: 'greaterThan',
    name: 'is greater than',
    control: 'number',
  },
  lessThan: {
    id: 'lessThan',
    name: 'is less than',
    control: 'number',
  },
};

const dateOperators: { [key: string]: Operator } = {
  is: {
    id: 'is',
    name: 'is',
    control: 'date',
  },
  not: {
    id: 'not',
    name: 'is not',
    control: 'date',
  },
  before: {
    id: 'before',
    name: 'is before',
    control: 'date',
  },
  after: {
    id: 'after',
    name: 'is after',
    control: 'date',
  },
};

export {
  stringOperators,
  baseOperators,
  numberOperators,
  dateOperators,
}